import type { InfiniteTableRowInfo } from "@infinite-table/infinite-react";
import type { News, NewsRaw } from "epsm-api-types/models";
import { NEWS_DATASET } from "../../../types";
import { NewsBriefs } from "../NewsBriefs";
import { NewsText } from "../NewsText";

type Props = {
	newsItem: InfiniteTableRowInfo<NewsRaw>;
	setRowDetailHeight: (v: number) => void;
	setExpandedRowDetailList: React.Dispatch<React.SetStateAction<number[]>>;
};

export const NewsDetails: React.FC<Props> = (props) => {
	const { newsItem, setRowDetailHeight, setExpandedRowDetailList } = props;

	const newsData = newsItem.data as News;

	if (!newsData) return <p>No data</p>;

	return (
		<div className="flex gap-10 flex-col h-full text-white">
			{newsData.dataset === NEWS_DATASET.BRIEF ? (
				<NewsBriefs
					newsItem={newsItem}
					setRowDetailHeight={setRowDetailHeight}
					setExpandedRowDetailList={setExpandedRowDetailList}
				/>
			) : (
				<NewsText
					newsItem={newsItem}
					setRowDetailHeight={setRowDetailHeight}
					setExpandedRowDetailList={setExpandedRowDetailList}
				/>
			)}
		</div>
	);
};
